/**
 * Configurazione della copertina.
 *
 * Solo le variabili con prefisso `VITE_` finiscono nel bundle, quindi tutto ciò
 * che sta qui è pubblico: la copertina non ha niente da nascondere, ma la regola
 * resta la stessa del client.
 */
export const appUrl: string = import.meta.env.VITE_APP_URL ?? 'http://localhost:4200';

export const appVersion: string = import.meta.env.VITE_APP_VERSION ?? '0.0.0-dev';

/**
 * Misura d'uso di Google Analytics. Vuota — il default — significa nessuna
 * misura: in sviluppo non si sporca la proprietà con visite finte, e un
 * identificativo mancante in esercizio spegne la raccolta invece di far comparire
 * un banner che non chiede niente.
 */
export const analyticsMeasurementId: string = import.meta.env.VITE_GA_MEASUREMENT_ID ?? '';
